import { render } from "./MapContextMenu.vue?vue&type=template&id=05e48ef5"
import script from "./MapContextMenu.vue?vue&type=script&lang=js"
export * from "./MapContextMenu.vue?vue&type=script&lang=js"

import "./MapContextMenu.vue?vue&type=style&index=0&id=05e48ef5&lang=css"
script.render = render

export default script